// react
import { React } from 'react';

// mui
import { ListItem, ListItemText, ListItemButton, Typography } from '@mui/material';

// components
import { def } from '@goldblack/shared';

function FilterItemHead(props) {
    const filter = props.filter;
    return (
        <ListItemText
            sx={{ ml: 1 }}
            primary={
                <Typography variant='body2' color='primary.main'>
                    {filter.name}
                </Typography>
            }
        />
    );
}

function FilterItem(props) {
    return (
        <ListItem disablePadding>
            <ListItemButton
                autoFocus={props.installed}
                selected={props.selected}
                onClick={props.onClick}
                sx={{
                    m: 0,
                    backgroundColor: props.filter.status === def.FilterStatus.INACTIVE ? 'action.disabled' : '',
                }}>
                <FilterItemHead filter={props.filter} button={props.button} />
            </ListItemButton>
        </ListItem>
    );
}

export { FilterItem };
